//      
                                 
import axios from "axios";
import Configuration from "../Configuration";
                                                                  
                                                   
                                             
                                                   
                                             
                                         
import {SPECIAL_CATEGORY} from "../actions/filter";

                                
                       
                     
                    
                         
                    
                  
                       
             
 

                                  
                
                        
                                    
                   
 

                             
                  
                
                                       
                    
   
                
             
                   
                         
                 
                       
                        
   
                
                     
                            
                               
                                
                             
                             
   
                         
                         
                               
                                  
  
 

                                  
                       
                  
                         
                    
                  
                  
 

                                    
                      
                              
                        
                      
                                
               
                                        
                           
 

                                      
                
                  
              
           
                      
                  
   
                              
                       
                        
                      
                               
                         
                            
                                 
                       
                            
                                         
                
   
         
                     
                  
                         
                        
                      
                          
   
                              
  

export const CONFIG_ID_TYPE = {
	DISTRIBUTOR: "DISTRIBUTOR",
	DEALER: "DEALER",
	GARAGE: "GARAGE",
	GARAGE_GROUP: "GARAGE_GROUP",
};
export const INTENT = {
	DEFAULT: "DEFAULT",
	DISTRIBUTOR: "DISTRIBUTOR",
	EXCLUDE_LIFESTYLE: "EXCLUDE_LIFESTYLE",
	VOLVO_SELEKT: "VOLVO_SELEKT",
};

export default class ProductApi {
	api       ;

	constructor(configId        , language        , intent        , configIdType         = CONFIG_ID_TYPE.DEALER) {
		const headers = {
			"Content-Type": "application/json",
			"X-ConfigId": configId,
			"X-ConfigIdType": configIdType,
			"X-Intent": intent,
			"X-ModuleType": "SELEKT",
			"Accept-Language": language + ", *;q0.5",
		};
		this.api = axios.create({
			baseURL: Configuration.value("apiBaseUrl"),
			headers,
		});
	}

	getProducts = (config                    , filterParameters                    , pageSize         ) => {
		const {vehicle} = config;
		const {fuzzy, page, categoryKey, vehicleKey} = filterParameters;
		const body = {
			fuzzy,
			filterParameters: {
				categoryKey: SPECIAL_CATEGORY.listAll().includes(categoryKey) ? null : categoryKey,
				vehicleKey,
				vehicle
			},
			sortOrders: [{fieldname: "score", direction: "DESC"}]
		};

		pageSize = Math.min(pageSize || 5000, 100);
		return this.api.post(`/v2/products/search?page=${page}&size=${pageSize}`, body)
			.then(response => {
				return {
					products: response.data.pagedProducts.productItems,
					productCount: response.data.pagedProducts.totalItems,
					totalPages: response.data.pagedProducts.totalPages,
					filterStats: response.data.filterStats,
				};
			});
	};

	/**
	 * The first hits of a search, for the preview under the search box while the customer types. The
	 * filter is built the way getProducts builds it, so the preview shows what the result page shows -
	 * cut to a handful of products, with the categories they belong to.
	 */
	getSearchPreview = (config                    , filterParameters                    , size        ) => {
		const {vehicle} = config;
		const {fuzzy, categoryKey} = filterParameters;
		const body = {
			fuzzy,
			filterParameters: {
				categoryKey: SPECIAL_CATEGORY.listAll().includes(categoryKey) ? null : categoryKey,
				vehicle
			},
			sortOrders: [{fieldname: "score", direction: "DESC"}]
		};

		return this.api.post(`/v2/products/search?page=0&size=${size}`, body)
			.then(response => response.data);
	};

	getConfig = async ()                                  => {
		return this.api.get("/v2/configure")
			.then(response => response.data);
	};

	getProductDetails = (productId        , filterParameters                  ) => {
		const body = {
			filterParameters
		};
		return this.api.post(`/v2/productDetail/${productId}`, body)
			.then(response => response.data);
	};

	validateBookmarks = (dealerId        , bookmarks           = [])                     => {
		const defaultPage = 0;
		const defaultPageSize = 1000;

		const productIds = bookmarks;

		const body = {
			dealerId,
			productIds
		};

		return this.api.post(`/v2/products/search?page=${defaultPage}&size=${defaultPageSize}`, body)
			.then(response => response.data.pagedProducts.productItems);
	};

	validateCart = (items        )                  => {
		const defaultPage = 0;
		const defaultPageSize = 1000;

		const productIds = items.map(item => item.product.id);

		const body = {
			productIds
		};

		return this.api.post(`/v2/products/search?page=${defaultPage}&size=${defaultPageSize}`, body)
			.then(response => response.data.pagedProducts.productItems);
	};
}
